import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/mainLogo.png";
import "../../assets/style/Sidebar.css";
import {
  FaHome,
  FaTable,
  FaChevronDown,
  FaChevronUp,
  FaUsers,
  FaCodeBranch,
  FaUserGraduate,
  FaRegHandshake,
} from "react-icons/fa";
import { BiWorld } from "react-icons/bi";
import { TbTax } from "react-icons/tb";
import { FaBuildingUser } from "react-icons/fa6";
import { SiMainwp } from "react-icons/si";
import {
  MdMarkEmailRead,
  MdOutlineAccessTimeFilled,
  MdOutlineDateRange,
} from "react-icons/md";
import { TfiSettings } from "react-icons/tfi";
import { IoMdLogOut } from "react-icons/io";
import { toast } from "react-toastify";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";

const Sidebar = ({userAccessData}) => {
  const userAccess = userAccessData?.permission;
  // const handleClick = () => setClick(!click);
    const { setUserAccess } = useUser("");
    const navigate = useNavigate();
    const [ isOpen, setIsOpen ] = useState(false);
    const location = useLocation();
    const userType = localStorage.getItem("user_type");
    const cpc_allowed = localStorage.getItem("cpc_allowed");
    const masters_allowed = localStorage.getItem("masters_allowed");
    const customer_allowed = localStorage.getItem("customer_allowed");
    const emp_allowed = localStorage.getItem("emp_allowed");
    const help_allowed = localStorage.getItem("help_allowed");
    const settings_allowed = localStorage.getItem("settings_allowed");
    const roles_allowed = localStorage.getItem("roles_allowed");
  const [masterSubmenuOpen, setMasterSubmenuOpen] = useState(false);

  const toggleMasterSubmenu = () => {
    setMasterSubmenuOpen(!masterSubmenuOpen);
  };
  const fetchData = async () => {
    try {
        const result = await getData("/api/user-access");
        if (result.success) {
            setUserAccess(result);
        }
    } catch (error) {
        console.log("Error:123213", error);
    }
};
  const handleLogout = () => {
      // Clear all relevant localStorage items
    localStorage.removeItem("token");
    localStorage.removeItem("financial_year");
    localStorage.removeItem("theme_settingtest");
    localStorage.removeItem("user_type");
    localStorage.removeItem("employee_type");
    localStorage.removeItem("username");
    localStorage.removeItem("cpc_allowed");
    localStorage.removeItem("customer_allowed");
    localStorage.removeItem("masters_allowed");
    localStorage.removeItem("emp_allowed");
    localStorage.removeItem("help_allowed");
    localStorage.removeItem("settings_allowed");
    localStorage.removeItem("cpc_db");
    localStorage.removeItem("roles_allowed");
    localStorage.removeItem("all_branches");
    localStorage.removeItem("isLoggedIn");
    
    sessionStorage.removeItem("isLoggedIn");
    
    toast.success("Logout successful");
    
    // navigate("/login");
    setTimeout(() => {
      // navigate(
      //     "/dashboard"
      // );

      window.location.replace("/login");
    }, 1000);
  };

  return (
    <aside className="argon-sidebar">
      <div className="argon-brand">
        <img src={logo} alt="Argon Chakra" className="brand-logo" />
      </div>

      <nav className="argon-nav-main">
        <NavLink
          to="/"
          className={({ isActive }) =>
            `argon-nav-item ${isActive ? "active" : ""}`
          }
        >
          <span className="argon-nav-icon">
            <FaHome />
          </span>
          <span>Dashboard</span>
        </NavLink>

        {/* Master section with submenu */}
        {
          userType === "CPA" &&
        <div className="argon-nav-item-with-submenu">
          <div className="argon-nav-item" onClick={toggleMasterSubmenu}>
            <span className="argon-nav-icon">
              <FaTable />
            </span>
            <span>Master</span>
            <span className="argon-submenu-icon">
              {masterSubmenuOpen ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>

          {/* Submenu items */}
          {masterSubmenuOpen && (
            <div className="argon-submenu">
              <NavLink
                to="/master/branch"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <FaCodeBranch />
                </span>
                <span>Branch</span>
              </NavLink>

              <NavLink
                to="/master/state"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <BiWorld />
                </span>
                <span>State</span>
              </NavLink>

              <NavLink
                to="/master/taxtable"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <TbTax />
                </span>
                <span>Tax Table</span>
              </NavLink>
              <NavLink
                to="/master/department"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <FaBuildingUser />
                </span>
                <span>Department</span>
              </NavLink>
              <NavLink
                to="/master/designation"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <FaUserGraduate />
                </span>
                <span>Designation</span>
              </NavLink>
              <NavLink
                to="/master/taxhead"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <SiMainwp />
                </span>
                <span>Tax Head</span>
              </NavLink>
              <NavLink
                to="/master/financialyear"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <MdOutlineDateRange />
                </span>
                <span>Financial Year</span>
              </NavLink>
              <NavLink
                to="/master/cutofdate"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <MdOutlineAccessTimeFilled />
                </span>
                <span>Cut off Date</span>
              </NavLink>
              <NavLink
                to="/master/emailtemplates"
                className={({ isActive }) =>
                  `argon-submenu-item ${isActive ? "active" : ""}`
                }
              >
                <span className="argon-nav-icon">
                  <MdMarkEmailRead />
                </span>
                <span>Email Templates</span>
              </NavLink>
            </div>
          )}
        </div>
        }
        {
          userType !== "Admin" &&
        <NavLink
          to="/Client"
          className={({ isActive }) =>
            `argon-nav-item ${isActive ? "active" : ""}`
          }
        >
          <span className="argon-nav-icon">
            <FaRegHandshake />
          </span>
          <span>Client</span>
        </NavLink>
        }
        {
          userType === "Admin" &&
        <NavLink
          to="/Cpalisting"
          className={({ isActive }) =>
            `argon-nav-item ${isActive ? "active" : ""}`
          }
        >
          <span className="argon-nav-icon">
            <FaRegHandshake />
          </span>
          <span>CPA</span>
        </NavLink>
        }
        {
          userType === "CPA" &&
        <NavLink
          to="/employees"
          className={({ isActive }) =>
            `argon-nav-item ${isActive ? "active" : ""}`
          }
        >
          <span className="argon-nav-icon">
            <FaUsers />
          </span>
          <span>Employees</span>
        </NavLink>
        }
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            `argon-nav-item ${isActive ? "active" : ""}`
          }
        >
          <span className="argon-nav-icon">
            <TfiSettings />
          </span>
          <span>Settings</span>
        </NavLink>
        <div
          className="argon-nav-item"
          onClick={handleLogout}
        >
          <span className="argon-nav-icon">
            <IoMdLogOut />
          </span>
          <span>Logout</span>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;